module.exports = __webpack_public_path__ + "img/deleteIcon.9928f427.svg";